import React from 'react';

import { styled } from '@mui/material/styles';
import UIKitMenuItem from './MenuItem';
import { UIKitCheckbox } from './CheckBox';
import { ThemeColor } from '../theme';

interface UIKitMenuItemCheckboxStyleProps {
  /** ThemeColor del checkbox (primary, secondary, success, error, warning, tertiary) */
  color?: ThemeColor;
  /** className específico para el checkbox */
  className?: string;
  /** style específico para el checkbox */
  style?: React.CSSProperties;
}

interface UIKitMenuItemCheckboxProps {
  text: string;
  onChange?: (value: boolean) => void;
  disabled?: boolean;
  checked?: boolean;
  indeterminate?: boolean;

  /** Estilos / color específicos del checkbox embebido */
  checkboxStyles?: UIKitMenuItemCheckboxStyleProps;

  /** Estilos del row del menú */
  className?: string;
  style?: React.CSSProperties;
}

// saca el padding extra que agranda el alto del item
const StyledCheckbox = styled(UIKitCheckbox)({
  padding: 0,
  '&:hover': {
    backgroundColor: 'transparent',
  },
  '&.Mui-focusVisible': {
    backgroundColor: 'transparent',
  },
});

const UIKitMenuItemCheckbox = React.forwardRef<HTMLLIElement, UIKitMenuItemCheckboxProps>(
  ({ text, checked, indeterminate, disabled, onChange, checkboxStyles, className, style }, ref) => {
    const handleToggle = () => {
      if (disabled || !onChange) {
        return;
      }
      onChange(!checked);
    };

    // color del checkbox
    let checkboxColor: ThemeColor = 'primary';
    if (checkboxStyles && checkboxStyles.color) {
      checkboxColor = checkboxStyles.color;
    }

    // style del checkbox
    let checkboxStyle: React.CSSProperties | undefined;
    if (checkboxStyles && checkboxStyles.style) {
      checkboxStyle = checkboxStyles.style;
    }

    return (
      <UIKitMenuItem
        ref={ref}
        text={text}
        disabled={disabled}
        selected={!!checked}
        onClick={handleToggle}
        className={className}
        style={style}
        leading={
          <StyledCheckbox
            checked={checked}
            indeterminate={indeterminate}
            color={checkboxColor}
            tabIndex={-1}
            className={checkboxStyles && checkboxStyles.className}
            style={checkboxStyle}
            onClick={(e) => {
              e.stopPropagation();
              handleToggle();
            }}
          />
        }
      />
    );
  }
);

export default UIKitMenuItemCheckbox;
